module.exports = __webpack_public_path__ + "img/icon_today.2d3e2092.png";